{
  "auth.acceptInvite.alreadyMember": "You are already a member of this {kind}.",
  "auth.acceptInvite.createAccount": "Create account and join",
  "auth.acceptInvite.expired": "This invitation has expired. Ask the sender for a new invite.",
  "auth.acceptInvite.generic": "Something went wrong while accepting the invitation.",
  "auth.acceptInvite.goToWorkspace": "Go to workspace",
  "auth.acceptInvite.h.error": "Invitation problem",
  "auth.acceptInvite.h.joining": "Accepting invitation",
  "auth.acceptInvite.h.joiningNamed": "Joining {name}",
  "auth.acceptInvite.h.mismatch": "Wrong account",
  "auth.acceptInvite.h.redirect": "Sign in to continue",
  "auth.acceptInvite.h.success": "Invitation accepted",
  "auth.acceptInvite.h.welcome": "You are invited",
  "auth.acceptInvite.h.welcomeNamed": "Join {name}",
  "auth.acceptInvite.haveAccount": "I already have an account",
  "auth.acceptInvite.inactive": "This invitation is no longer active. Ask the sender for a new invite.",
  "auth.acceptInvite.invalid": "This invitation link is invalid. The link may be incomplete or superseded.",
  "auth.acceptInvite.invalidOrExpired": "This invitation link is invalid or has expired. Ask the sender for a new invite.",
  "auth.acceptInvite.joined": "You have joined the {kind}.",
  "auth.acceptInvite.kind.invitation": "invitation",
  "auth.acceptInvite.kind.organization": "organization",
  "auth.acceptInvite.kind.project": "project",
  "auth.acceptInvite.kind.team": "team",
  "auth.acceptInvite.kind.workspace": "workspace",
  "auth.acceptInvite.kindIn.invitation": "an invitation",
  "auth.acceptInvite.kindIn.organization": "an organization",
  "auth.acceptInvite.kindIn.project": "a project",
  "auth.acceptInvite.kindIn.team": "a team",
  "auth.acceptInvite.kindIn.workspace": "a workspace",
  "auth.acceptInvite.kindOf.invitation": "invitation",
  "auth.acceptInvite.kindOf.organization": "organization",
  "auth.acceptInvite.kindOf.project": "project",
  "auth.acceptInvite.kindOf.team": "team",
  "auth.acceptInvite.kindOf.workspace": "workspace",
  "auth.acceptInvite.kindTo.invitation": "invitation",
  "auth.acceptInvite.kindTo.organization": "organization",
  "auth.acceptInvite.kindTo.project": "project",
  "auth.acceptInvite.kindTo.team": "team",
  "auth.acceptInvite.kindTo.workspace": "workspace",
  "auth.acceptInvite.linkUsed": "This invite link no longer works: someone already used it, or it was turned off. Ask the person who shared it for a new link.",
  "auth.acceptInvite.mismatch": "This invitation was sent to {invited}. You are signed in as {current}. Sign out, then open the invite link again.",
  "auth.acceptInvite.missingToken": "Open the invitation link again to join. For your safety, this page does not keep the link after a reload.",
  "auth.acceptInvite.notFound": "This invitation could not be found. The link may be incomplete.",
  "auth.acceptInvite.openWorkspace": "Open workspace",
  "auth.acceptInvite.p.as": " ({email})",
  "auth.acceptInvite.p.checking": "Checking your {kind} invitation…",
  "auth.acceptInvite.p.redirect": "Taking you to sign-in — the invitation stays attached.",
  "auth.acceptInvite.p.welcome": "{who}{where}{as}. Create an account to join, or sign in if you already have one.",
  "auth.acceptInvite.p.whereKind": " to {kind}",
  "auth.acceptInvite.p.whereNamed": " to {name}",
  "auth.acceptInvite.p.whereNamedOrg": " to {name} at {org}",
  "auth.acceptInvite.p.who": "You have been invited",
  "auth.acceptInvite.p.whoNamed": "{name} invited you",
  "auth.acceptInvite.switchAccount": "Switch account",
  "auth.acceptInvite.verifyFirst": "Verify your email to join. Open the link we sent to your inbox, then open this invitation link again.",
  "auth.acceptInvite.wrongEmail": "This invitation was sent to a different email address. Sign out and sign back in with the invited email.",
  "auth.callback.backToSignIn": "Back to sign in",
  "auth.callback.error.accessDenied": "You cancelled the sign-in, or access was not granted. Try again.",
  "auth.callback.error.expired": "This sign-in link is no longer valid. Start again from the sign-in page.",
  "auth.callback.error.generic": "Sign-in failed. Please try again.",
  "auth.callback.error.linkMalformed": "Sign-in link is missing or malformed. Open the link from your email again.",
  "auth.callback.error.missingCode": "Missing OAuth code in callback URL.",
  "auth.callback.error.network": "Network error. Please try again.",
  "auth.callback.error.unavailable": "Sign-in is unavailable right now. Please try again in a moment.",
  "auth.callback.error.unverifiedEmail": "Your email is not verified yet. Verify it with your sign-in provider, then try again.",
  "auth.callback.hydrating": "Hydrating session…",
  "auth.callback.loadingAccount": "Loading your account…",
  "auth.callback.persisting": "Persisting session…",
  "auth.callback.redirecting": "Done. Redirecting…",
  "auth.callback.signingIn": "Signing you in…",
  "auth.callback.verifyingGithub": "Verifying with GitHub…",
  "auth.callback.verifyingLink": "Verifying your sign-in link…",
  "auth.confirm.eyebrow": "Email confirmation",
  "auth.confirm.heading": "Verifying your email",
  "auth.confirm.loading": "Confirming your email...",
  "auth.emailConfirmFailed.body": "Unable to confirm your email. Please try again or contact support.",
  "auth.emailConfirmFailed.title": "Confirmation Failed",
  "auth.emailConfirmed.action": "Go to Sign In",
  "auth.emailConfirmed.body": "Your email has been successfully confirmed. You can now sign in to your account.",
  "auth.emailConfirmed.title": "Email Confirmed!",
  "auth.emailTaken.title": "This email is already in use",
  "auth.emailTaken.body": "Another Symbols account already uses this email, so we did not change your email. If that account is yours, sign in to it.",
  "auth.confirm.continueBody": "Press Continue to confirm this email address and sign in to its account:",
  "auth.confirm.continue": "Continue",
  "auth.confirm.otherAccount": "You are signed in as {email}. Continue signs you out of that account.",
  "auth.confirm.otherAccountUnnamed": "You are signed in as {email}. Continue can sign you in to a different account.",
  "auth.confirm.switchContinue": "Sign out and continue",
  "auth.confirm.invalidLink": "This confirmation link is not valid.",
  "auth.setPassword.title": "Set a password",
  "auth.setPassword.body": "Your email is confirmed and you are signed in. Set a password to sign in with it next time, or skip and sign in with an email link.",
  "auth.setPassword.label": "New password",
  "auth.setPassword.placeholder": "Choose a password",
  "auth.setPassword.save": "Save password",
  "auth.setPassword.skip": "Skip",
  "auth.setPassword.error": "The password was not saved. Try again, or skip.",
  "auth.google.authFailed.message": "Google authentication was cancelled or failed.",
  "auth.google.authFailed.title": "Authentication failed",
  "auth.google.incomplete": "Sign-in did not complete ({error}). Please try again.",
  "auth.google.incompleteGeneric": "Failed to complete Google sign-in.",
  "auth.google.securityError.message": "Authentication failed due to security check.",
  "auth.google.securityError.title": "Security error",
  "auth.google.stateMismatch.message": "Sign-in session did not match — please try again.",
  "auth.google.stateMismatch.title": "Security check failed",
  "auth.google.unreachable": "Unable to connect to Google. Please try again.",
  "auth.login.alternativeBody": "Use your Google or GitHub account.",
  "auth.login.alternativeHeading": "Another way to sign in",
  "auth.login.devApi.message": "The local API rejected every token with a signature mismatch — it is running without its JWT secret. Your session was NOT cleared. Restart the dev API (~/www/deploy/bin/dev.sh) and reload; signing in again will not help.",
  "auth.login.devApi.title": "Dev API is misconfigured",
  "auth.login.email": "Email",
  "auth.login.emailOrUsername": "Email or username",
  "auth.login.emailOrUsernamePlaceholder": "e.g. hello@symbo.ls or username",
  "auth.login.forgot": "Forgot your password?",
  "auth.login.github": "Sign in with Github",
  "auth.login.githubStartFailed": "Failed to start GitHub sign-in",
  "auth.login.githubUnavailable.message": "githubClientId is not configured for this environment.",
  "auth.login.githubUnavailable.title": "GitHub sign-in unavailable",
  "auth.login.google": "Sign in with Google",
  "auth.login.googleFailed": "Failed to sign in with Google",
  "auth.login.googleNativeHint": "Google sign-in opens in your browser soon — use email for now",
  "auth.login.googleNotInApp.message": "Google sign-in opens in your browser soon — use email for now.",
  "auth.login.googleNotInApp.title": "Google sign-in is not available in the app yet",
  "auth.login.googleSignInFailed": "Google sign-in failed",
  "auth.login.googleUnavailable.message": "Google identity script did not load.",
  "auth.login.googleUnavailable.title": "Google sign-in unavailable",
  "auth.login.heading": "Sign in to Symbols",
  "auth.login.password": "Password",
  "auth.login.sub": "Use your work email and password.",
  "auth.login.submit": "Sign in",
  "auth.login.title": "Sign in",
  "auth.login.tryAgain": "Please try again.",
  "auth.login.welcome": "Welcome",
  "auth.page.acceptInvite.title": "Accept invitation",
  "auth.page.callback.title": "Signing you in / Symbols",
  "auth.page.resetPassword.title": "Reset password / Symbols",
  "auth.page.signin.title": "Sign in / Symbols",
  "auth.page.signin.titlePlain": "Sign in",
  "auth.page.signup.title": "Create account",
  "auth.page.signupConfirmation.title": "Confirm email / Symbols",
  "auth.page.waitlistInvite.title": "Join Symbols / Symbols",
  "auth.resetEmail.label": "Email",
  "auth.resetEmail.placeholder": "e.g. hello@symbo.ls",
  "auth.resetEmail.required": "Email field is required",
  "auth.resetEmail.sending": "Sending…",
  "auth.resetEmail.submit": "Reset password",
  "auth.resetPassword.emailRequired.message": "Enter the email associated with your account.",
  "auth.resetPassword.emailRequired.title": "Email required",
  "auth.resetPassword.heading.request": "Reset your password",
  "auth.resetPassword.heading.set": "Set a new password",
  "auth.resetPassword.linkSent.message": "Check your inbox at {email}.",
  "auth.resetPassword.linkSent.title": "Reset link sent",
  "auth.resetPassword.mismatch": "Passwords do not match",
  "auth.resetPassword.mismatchMessage": "Make sure both fields are identical.",
  "auth.resetPassword.mismatchTitle": "Passwords do not match",
  "auth.resetPassword.missingFields.message": "Both password fields are required.",
  "auth.resetPassword.missingFields.title": "Missing fields",
  "auth.resetPassword.newLabel": "Type in new password",
  "auth.resetPassword.placeholder": "Password",
  "auth.resetPassword.repeatLabel": "Repeat new password",
  "auth.resetPassword.repeatRequired": "Repeat password field is required",
  "auth.resetPassword.required": "Password field is required",
  "auth.resetPassword.sendFailed": "Failed to send reset link",
  "auth.resetPassword.sentNotice": "Check your inbox at {email}. Follow the link to set a new password.",
  "auth.resetPassword.sentNoticeNoEmail": "Check your inbox. Follow the link to set a new password.",
  "auth.resetPassword.submit": "Confirm",
  "auth.resetPassword.updateFailed": "Failed to update password",
  "auth.resetPassword.updated.message": "You can sign in with your new password now.",
  "auth.resetPassword.updated.title": "Password updated",
  "auth.resetPassword.updating": "Updating…",
  "auth.signin.failed": "Failed to sign in",
  "auth.signin.failedMessage": "Please check your credentials and try again.",
  "auth.signin.missingFields.message": "Email/username and password are required.",
  "auth.signin.missingFields.title": "Missing fields",
  "auth.signup.accountType": "Account type",
  "auth.signup.accountTypePlaceholder": "Select account type…",
  "auth.signup.alreadyCredits.message": "Check your email to confirm your account.",
  "auth.signup.alreadyCredits.title": "You already have credits",
  "auth.signup.alternativeHeading": "Another way to sign up",
  "auth.signup.checkEmail.hint": "It can take a few minutes. Check your spam folder too.",
  "auth.signup.checkEmail.sent": "We sent a confirmation link to {email}.",
  "auth.signup.checkEmail.title": "Check your email",
  "auth.signup.creating": "Creating account…",
  "auth.signup.creditsAdded.message": "Check your email to confirm your account — your workspace already has {credits} credits ready to use.",
  "auth.signup.creditsAdded.title": "100 free credits added",
  "auth.signup.done.continue": "Continue to sign in",
  "auth.signup.email": "Email",
  "auth.signup.emailPlaceholder": "e.g. hello@symbo.ls",
  "auth.signup.failed": "Failed to create account",
  "auth.signup.github": "Continue with GitHub",
  "auth.signup.google": "Continue with Google",
  "auth.signup.haveAccount.link": "Sign in",
  "auth.signup.haveAccount.prompt": "Already have an account?",
  "auth.signup.heading": "Create your Symbols account",
  "auth.signup.headingNamed": "Create your {name} account",
  "auth.signup.headingNeutral": "Create your account",
  "auth.signup.invite.bound": "Create your account to join. The invited email is already set.",
  "auth.signup.invite.boundNamed": "{name} invited you. Create your account to join. The invited email is already set.",
  "auth.signup.invite.link": "Create your account with any email to join.",
  "auth.signup.invite.linkNamed": "{name} invited you. Create your account with any email to join.",
  "auth.signup.inviteReady.message": "Sign in to open your invitation.",
  "auth.signup.inviteReady.messageSignedIn": "Continue to open your invitation.",
  "auth.signup.inviteReady.title": "Your account is ready",
  "auth.signup.inviteReady.verify": "We sent a link to verify your email. Verify it, then sign in to join.",
  "auth.signup.inviteReady.verifySignedIn": "We sent a link to verify your email. Verify it, then join.",
  "auth.signup.legal.newTab": "opens in a new tab",
  "auth.signup.legal.privacy": "Privacy policy",
  "auth.signup.legal.privacyHref": "https://symbols.app/privacy",
  "auth.signup.legal.terms": "Terms of Service",
  "auth.signup.legal.termsHref": "https://symbols.app/terms",
  "auth.signup.missingFields.message": "Name, email, and password are all required.",
  "auth.signup.missingFields.title": "Missing fields",
  "auth.signup.name": "Full name",
  "auth.signup.namePlaceholder": "e.g. Mike",
  "auth.signup.notSent.message": "We could not send the confirmation email to {email}. Your account is ready: continue to sign in.",
  "auth.signup.notSent.messageSignedIn": "We could not send the confirmation email to {email}. Your account is ready.",
  "auth.signup.notSent.title": "Your account is ready",
  "auth.signup.password": "Password",
  "auth.signup.passwordRule.digit": "A number",
  "auth.signup.passwordRule.failed": "That password does not meet the rule. Change it and try again.",
  "auth.signup.passwordRule.length": "At least {count} characters",
  "auth.signup.passwordRule.lower": "A lowercase letter",
  "auth.signup.passwordRule.met": "met",
  "auth.signup.passwordRule.special": "One of {chars}",
  "auth.signup.passwordRule.text": "Use at least 8 characters, with a lowercase letter, an uppercase letter, a number and one of @ $ ! % * ? &.",
  "auth.signup.passwordRule.unmet": "not met",
  "auth.signup.passwordRule.upper": "An uppercase letter",
  "auth.signup.resend.action": "Send the email again",
  "auth.signup.resend.failed": "We could not send it again. Try again in a minute.",
  "auth.signup.resend.sent": "Sent again to {email}.",
  "auth.signup.resend.wait": "Send again in {seconds} s",
  "auth.signup.submit": "Sign up",
  "auth.waitlist.body": "You're joining the waitlist. Knowing your preferences helps us customize your invitation.",
  "auth.waitlist.emailPlaceholder": "Email",
  "auth.waitlist.heading": "Get early access",
  "auth.waitlist.namePlaceholder": "Name",
  "auth.waitlist.submit": "Sign up to waitlist",
  "auth.waitlistInvite.opening": "Opening signup…",
  "auth.whitelabel.alreadyInvited": "You already have an invitation — check your inbox, including spam.",
  "auth.whitelabel.captchaDown": "Verification is temporarily unavailable. Please try again shortly.",
  "auth.whitelabel.demo.hint": "Jump into a seeded workspace — no password needed.",
  "auth.whitelabel.demo.note": "Demo logins are seeded accounts for evaluation.",
  "auth.whitelabel.demo.title": "Quick access (demo)",
  "auth.whitelabel.email": "Email",
  "auth.whitelabel.emailPlaceholder": "e.g. you@example.com",
  "auth.whitelabel.genericError": "Something went wrong. Please try again.",
  "auth.whitelabel.google": "Continue with Google",
  "auth.whitelabel.googleFailed": "Google sign-in failed.",
  "auth.whitelabel.googleUnavailable": "Google sign-in is unavailable right now.",
  "auth.whitelabel.head.login": "Log in",
  "auth.whitelabel.head.signup": "Create your account",
  "auth.whitelabel.head.signupBranded": "Create your {brand} account",
  "auth.whitelabel.inbox": "Check your inbox — we have sent you your workspace invitation.",
  "auth.whitelabel.inboxBranded": "Check your inbox — we have sent you an invitation to the {brand} workspace.",
  "auth.whitelabel.needCaptcha": "Please complete the verification below and try again.",
  "auth.whitelabel.needCredentials": "Enter your email and password.",
  "auth.whitelabel.needEmail": "Please enter a valid email address.",
  "auth.whitelabel.needName": "Please enter your name.",
  "auth.whitelabel.needRole": "Please choose how you work with the team.",
  "auth.whitelabel.needValidOption": "Please choose a valid option.",
  "auth.whitelabel.networkError": "Network error. Please try again.",
  "auth.whitelabel.or": "or",
  "auth.whitelabel.password": "Password",
  "auth.whitelabel.persona.aria": "Sign in as {name}",
  "auth.whitelabel.request.email": "Work email",
  "auth.whitelabel.request.name": "Your name",
  "auth.whitelabel.request.namePlaceholder": "Jane Dupont",
  "auth.whitelabel.request.note": "We review every request. If it is a fit you will receive an invitation by email.",
  "auth.whitelabel.request.role": "How do you work with the team?",
  "auth.whitelabel.request.sending": "Sending…",
  "auth.whitelabel.request.submit": "Request an invitation",
  "auth.whitelabel.requestReceived": "Request received. The team will be in touch by email.",
  "auth.whitelabel.role.aria": "Account type: {name}",
  "auth.whitelabel.signinFailed": "Sign in failed. Check your details.",
  "auth.whitelabel.signinUnavailable": "That sign-in is not available.",
  "auth.whitelabel.signingIn": "Signing in…",
  "auth.whitelabel.signupSoon": "Sign-up opens shortly — in the meantime, reach the team and they will set you up.",
  "auth.whitelabel.signupUnavailable": "Sign-up is not available right now.",
  "auth.whitelabel.sub.login": "Use your account to continue.",
  "auth.whitelabel.sub.signup": "Start by choosing what kind of account this is — it decides which part of the programme opens for you.",
  "auth.whitelabel.submit": "Log in",
  "auth.whitelabel.switchToLogin": "Already have an account? Log in",
  "auth.whitelabel.switchToSignup": "New here? Create an account",
  "auth.whitelabel.tooMany": "Too many requests. Please try again shortly.",
  "auth.whitelabel.unavailable": "Unavailable.",
  "auth.whitelabel.wordmarkFallback": "Sign in"
}
